import Emitter from "./Emitter";

export default class Resize extends Emitter {
    constructor(gb) {
        super(gb);
    }

    BP_handler() {
        this.emitGame({
                type: "resize",
                width: this.gb.clientWidth,
                height: this.gb.clientHeight
            }
        );
    }

    _default(sizeObj) {
        let passObj = {};
        if (sizeObj && sizeObj.height) {
            passObj.height = sizeObj.height;
        }
        if (sizeObj && sizeObj.width) {
            passObj.width = sizeObj.width;
        }
        this.emitGame({ wpgaction: "resize", param: passObj });
    }
}
